import React from "react";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import Button from "@mui/material/Button";

export default function CustomToolbar({ setOpen }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ margin: 10 }}
        onClick={() => setOpen(true)}
      >
        add user
      </Button>
    </div>
  );
}
